module.exports = __webpack_public_path__ + "assets/img/my-sub-bg-vip.0604636f.png";